module.exports = __webpack_public_path__ + "img/michaeljburry-tweet.ad135e60.jpg";